import crownPacificFineFoodsLogo from "/img/integration/crownpacificfinefoods.png"
import { ConnectEmailPage } from "@/setup/connect/connect-email-page"
import { EmailConfigPage } from "@/setup/config/email-config-page"
import { BackToSettingsButton } from "@/setup/connect/settings-connect-layout"

export function SettingsConnectCrownPacificFineFoodsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectEmailPage
        logo={crownPacificFineFoodsLogo}
        logoAlt="Crown Pacific Fine Foods"
        integrationName="crownpacificfinefoods"
        description="Crown Pacific Fine Foods sends deduction and dispute information via email. Connect the email account(s) that receive Crown Pacific Fine Foods communications."
        redirectTo="/settings/config/crownpacificfinefoods"
      />
    </div>
  )
}

export function SettingsConfigCrownPacificFineFoodsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <EmailConfigPage
        logo={crownPacificFineFoodsLogo}
        logoAlt="Crown Pacific Fine Foods"
        integrationName="crownpacificfinefoods"
        displayName="Crown Pacific Fine Foods"
        connectPath="/settings/connect/crownpacificfinefoods"
      />
    </div>
  )
}
